module.exports = __webpack_public_path__ + "static/media/carousel4.8aba1cc5.gif";